// extracted by mini-css-extract-plugin
export default {"thanksSection":"Thanks_thanksSection__ipIHm","thanksText":"Thanks_thanksText__fHin2","show":"Thanks_show__1divh"};